interface Feature {
  icon: string;
  title: string;
  desc: string;
}

const features: Feature[] = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用先进的CDN加速与图片压缩技术，漫画加载速度飞快，翻页切换丝滑流畅，即使弱网环境也能畅快阅读。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '网页版、iOS、Android三端数据实时同步，阅读进度、收藏书签无缝衔接，换设备也不中断阅读体验。',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '夜间模式',
    desc: '智能护眼夜间模式，支持暖色调与暗色调自由调节，深夜追漫不伤眼，沉浸在舒适阅读氛围中。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线下载',
    desc: '支持批量离线下载漫画章节，地铁通勤、飞行途中也能畅快阅读，不受网络限制，随时随地追更。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">特色功能</h2>
          <p className="text-sm text-foreground-500">为什么数百万读者选择贝勒漫画？看这里就知道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}